import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { toggleSwitch, 
        dayChange } from '../../actions/index'
import { _ } from '../../functions/translator.js'
import { ToggleActions } from '../../constants/constants.js';
import { previousMonth } from '../../functions/utils.js';

class TimelineSwitch extends React.Component{

    handleTimelineChange = () => {
        // if (!this.props.timeline && this.props.metrics) {
        //     this.props.toggleSwitch(ToggleActions.METRICS, false);
        // }
        this.props.toggleSwitch(ToggleActions.TIMELINE);
        if (!this.props.timeline) {
            this.props.dayChange({
                first: this.props.projectData.days[this.props.projectData.days.length - 7].id, 
                last: this.props.projectData.days[this.props.projectData.days.length - 1].id
            })
        } else {
            this.props.dayChange({
                first: this.props.projectData.days[0].id, 
                last: this.props.projectData.days[this.props.projectData.days.length - 1].id
            })
        }
    };

    render() {
        return(
            <div>
                <FormGroup row>
                <FormControlLabel
                    className="text"
                    control={
                    <Switch
                        checked={this.props.timeline}
                        onChange={this.handleTimelineChange}
                        name="numbersCheck"
                        color="primary"
                    />
                    }
                    label={ _('Filtro de Tiempo') }
                />
                </FormGroup>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        timeline    : state.switches.timeline,
        metrics     : state.switches.metrics,
        projectData : state.projectData,
        day : state.day,
        projectData : state.projectData,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        dayChange : dayChange,
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TimelineSwitch);